import { SigninPageActions, AuthApiActions } from '../actions';

export interface State {
  error: string | null;
  pending: boolean;
}

export const initialState: State = {
  error: null,
  pending: false,
};

export function reducer(
    state = initialState,
    action: SigninPageActions.SigninPageActionsUnion | AuthApiActions.AuthApiActionsUnion
  ): State {
  switch (action.type) {
    case SigninPageActions.signin.type: {
      return {
        ...state,
        error: null,
        pending: true
      };
    }
    case SigninPageActions.autoLogin.type: {
      return {
        ...state,
        error: null,
        pending: false
      };
    }
    case SigninPageActions.autoLogout.type: {
      return {
        ...state,
        error: null,
        pending: false
      };
    }
    case AuthApiActions.loginSuccess.type: {
     return {
       ...state,
       error: null,
       pending: false
     };
    }
    case AuthApiActions.loginFailure.type: {
      return {
        ...state,
        error: action.error,
        pending: false
      };
    }
    case AuthApiActions.logoutSuccess.type: {
      return initialState;
    }
    case AuthApiActions.logoutFailure.type: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
